import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftCostServer } from "namirasoft-cost";
import { NamirasoftPaymentServer } from "namirasoft-payment";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { CostLayout } from "./CostLayout";
import { CostRoutes } from "./CostRoutes";
import CostEstimatorPage from "./pages/CostEstimatorPage";
import CostExplorerPage from "./pages/CostExplorerPage";
import CostListPage from "./pages/CostListPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_COST}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_COST = new EnvService("REACT_APP_BASE_URL_COST", true).getString();
            let REACT_APP_BASE_URL_PAYMENT = new EnvService("REACT_APP_BASE_URL_PAYMENT", true).getString();

            let cost = new NamirasoftCostServer(REACT_APP_BASE_URL_COST, result.account.token_manager, result.notifier.onError);
            let payment = new NamirasoftPaymentServer(REACT_APP_BASE_URL_PAYMENT, result.account.token_manager, result.notifier.onError);

            let servers = { cost, payment };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={CostRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={CostRoutes.CostList} element={<CostListPage {...result} servers={servers} />} />
                            <Route path={CostRoutes.CostExplorer} element={<CostExplorerPage {...result} servers={servers} />} />
                            <Route path={CostRoutes.CostEstimator} element={<CostEstimatorPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes>
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={CostRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <CostLayout {...props}>
                {props.children}
            </CostLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;